import {
  backButton,
  initData,
  invoice,
  miniApp,
  openLink as sdkOpenLink,
  openTelegramLink,
  retrieveLaunchParams,
  swipeBehavior,
  useRawInitData,
  useSignal,
} from '@tma.js/sdk-react';

// Keep Telegram SDK details at this boundary. Features consume application-level
// helpers, so client support checks and SDK migrations have a single owner.
export { retrieveLaunchParams, useRawInitData };
export type { InvoiceStatus } from '@tma.js/sdk-react';

export const useTelegramTheme = (): boolean => useSignal(miniApp.isDark);
export const useTelegramUser = () => useSignal(initData.user);
export const isTelegramDark = (): boolean => miniApp.isDark();

let verticalSwipeLocks = 0;
let restoreVerticalSwipes = false;

/** Keep a sheet's downward drag from minimizing the Telegram Mini App. */
export const lockTelegramVerticalSwipes = (): (() => void) => {
  if (!swipeBehavior.disableVertical.isAvailable()) return () => undefined;
  if (verticalSwipeLocks === 0) {
    restoreVerticalSwipes = swipeBehavior.isVerticalEnabled();
    swipeBehavior.disableVertical();
  }
  verticalSwipeLocks += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    verticalSwipeLocks -= 1;
    if (verticalSwipeLocks === 0 && restoreVerticalSwipes) {
      swipeBehavior.enableVertical.ifAvailable();
    }
  };
};

export const showBackButton = (): void => {
  backButton.show.ifAvailable();
};

export const hideBackButton = (): void => {
  backButton.hide.ifAvailable();
};

export const onBackButtonClick = (handler: () => void): (() => void) => {
  const result = backButton.onClick.ifAvailable(handler);
  return result.ok ? result.data : () => undefined;
};

export const isInvoiceAvailable = (): boolean => invoice.openUrl.isAvailable();
export const openInvoiceUrl = (url: string) => invoice.openUrl(url);

export const openLink = (url: string): void => {
  const target = new URL(url);
  if (target.protocol !== 'https:' && target.protocol !== 'http:') {
    throw new Error('Only HTTP and HTTPS links are supported.');
  }

  if (target.hostname === 't.me' && openTelegramLink.isAvailable()) {
    openTelegramLink(target.href);
  } else if (sdkOpenLink.isAvailable()) {
    sdkOpenLink(target.href);
  } else {
    window.open(target.href, '_blank', 'noopener,noreferrer');
  }
};
